import { createContext } from "react";

export interface IPageHeaderContext {
  onFiltersApply?: () => void;
  onFiltersClear?: () => void;
  onSearchApply?: () => void;
}

export const PageHeaderContext = createContext<IPageHeaderContext>({});
